module.exports = __webpack_public_path__ + "img/slider-home-3@2x.3a259e0a.png";